import React, {useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import TextEditor from '../../../textEditor/TextEditor';
import {uploadFile} from '../../../../redux/user/userActions';
import * as css from './EmailTab.css';
import {TState} from '../../../../redux/store.type';
import {TEmailProps} from '../../types';
import EmailTabImage from './EmailTabImage';
import ImageHeader from '../../../../pages/branding/imageHeader/ImageHeader';
import EditorWrapper from '../../../textEditor/editorWrapper/EditorWrapper';

const EmailTab = ({emailBody, setEmailBody, emailSubject, setEmailSubject, image, saveImage, variablesType, buttons}: TEmailProps) => {
    const {t} = useTranslation('layout');
    const {t: tBranding} = useTranslation('branding');
    const lang = useSelector((s: TState) => s.user.lang);
    const uid = useSelector((s: TState) => s.user.uid);
    const quillSubjectRef = useRef(null);
    const defaultText = emailBody;
    const defaultSubject = emailSubject ? `<p>${emailSubject}</p>` : '';

    const handleImageSave = async (newImage) => {
        if(newImage?.image){
            saveImage(await uploadFile(newImage.image, '', 'emailImage', uid));
        }
    };
    return (
        <>
            <css.editorSection>
                <css.subjectEditor text={tBranding('emailSubject')}>
                    <TextEditor
                        defaultText={defaultSubject}
                        dependencies={[lang]} showToolbar={false} quillRef={quillSubjectRef}
                        onSave={()=>{}}
                        limit={{maxChar:80}}
                        lang={lang}
                        onChange={setEmailSubject}
                        variablesType={variablesType}
                    />
                </css.subjectEditor>
                <ImageHeader text={'emailImage'}/>
                <EmailTabImage
                    image={image}
                    saveImage={handleImageSave}
                />
                <css.bodyEditor>
                    <EditorWrapper 
                        text={t('freeText')}
                        defaultText={defaultText}
                        events={{onChange: setEmailBody}}
                        showToolbar={true}
                        dependencies={[]}
                        lang={lang} 
                        limit={undefined}
                        variablesType={variablesType}
                    />
                </css.bodyEditor>
                {buttons}
            </css.editorSection>
        </>
    );
};

export default EmailTab;
